/* eslint-disable default-case */
import {
    GET_VIDEOS,
    GET_VIDEO_BY_PLID,
    CLEAR_VIDEOS
} from '../actions/videoActions';
import uniqBy from 'lodash.uniqby';

const initialState = {};

export function video(state = initialState, action) {
    switch (action.type) {
        case GET_VIDEOS.pending:
        {
            return {
                ...state,
                videosIsFetching: true
            };
        }
        case GET_VIDEOS.fulfilled:
        {
            const rawVideos = !action.meta?.disablePagination && state?.videos?.length > 0 ? [ ...state.videos, ...action.payload.v ] : action.payload.v;
            const cleanVideosPayload = uniqBy(rawVideos, 'aid');

            return {
                ...state,
                videos: cleanVideosPayload,
                totalVideoCount: action.payload.vc,
                pageNumber: state?.pageNumber > 0 ? action.payload.p : 1,
                lastError: {},
                videosIsFetching: false
            };
        }
        case GET_VIDEOS.rejected:
        {
            return {
                ...state,
                videos: state?.videos?.length > 0 ? state.videos : [],
                lastError: action.payload,
                videosIsFetching: false
            };
        }

        case GET_VIDEO_BY_PLID.pending:
        {
            return {
                ...state,
                videoIsFetching: true
            };
        }
        case GET_VIDEO_BY_PLID.fulfilled:
        {
            const rawPlidVideos = state?.videos?.length > 0 ? [ action.payload, ...state.videos ] : [action.payload];
            const cleanPlidVideosPayload = uniqBy(rawPlidVideos, 'aid');

            return {
                ...state,
                videos: cleanPlidVideosPayload,
                lastError: {},
                videoIsFetching: false
            };
        }
        case GET_VIDEO_BY_PLID.rejected:
        {
            return {
                ...state,
                lastError: action.payload,
                videoIsFetching: false
            };
        }

        case CLEAR_VIDEOS:
        {
            return {
                videos: []
            };
        }
    }

    return state;

}
